import { GestureResponderEvent, Text, View } from "react-native";
import { Button, PopOver } from "../../components";

interface ModalProps {
  show: boolean;
  onSubmit: (e: GestureResponderEvent) => void;
}

export default ({ show, onSubmit }: ModalProps) => (
  <PopOver visible={show} onDismiss={() => false} dismissable={false}>
    <Text className="text-regular-normal font-700 text-ink-dark">Please set your home address.</Text>
    <Text className="text-regular-normal font-400 text-ink-dark mt-2">
      Please provide your current home address to ensure proper settings and up-to-date contact information.
    </Text>
    <View className="flex flex-row justify-end mt-4">
      <Button onPress={onSubmit} className="ml-2" size="small" mode="secondary">
        Add Home Address
      </Button>
    </View>
  </PopOver>
);
